'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('url-search-params-polyfill');

var getParameter = function getParameter(name) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var urlString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var urlParams = new URLSearchParams(urlString || window.location.search);
  return urlParams.get(name) || defaultValue;
};

exports.default = getParameter;


//////////////////
// WEBPACK FOOTER
// ./src/util/url.js
// module id = 34
// module chunks = 0